import { useState, useEffect } from 'react';

const useStripe = stripeApiKey => {
  const [stripeConfig, setStripeConfig] = useState(null);

  useEffect(() => {
    const stripeUrl = 'https://js.stripe.com/v3/';
    if (!document.querySelector('#stripe-js')) {
      const script = document.createElement('script');
      script.async = true;
      script.id = 'stripe-js';
      script.onload = () => {
        const stripe = window.Stripe(stripeApiKey);
        setStripeConfig(stripe);
      };
      document.head.appendChild(script);
      script.src = stripeUrl;
    } else if (window.Stripe) {
      const stripe = window.Stripe(stripeApiKey);
      setStripeConfig(stripe);
    }
  }, [stripeApiKey]);

  return [stripeConfig];
};

export default useStripe;
